var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _g, _rect, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6640_16243)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.584C2 10.5383 10.9543 1.58398 22 1.58398C33.0457 1.58398 42 10.5383 42 21.584C42 32.6297 33.0457 41.584 22 41.584C10.9543 41.584 2 32.6297 2 21.584Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.584C2.5 10.8144 11.2304 2.08398 22 2.08398C32.7696 2.08398 41.5 10.8144 41.5 21.584C41.5 32.3535 32.7696 41.084 22 41.084C11.2304 41.084 2.5 32.3535 2.5 21.584Z",
    stroke: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.875 20.2735C23.875 19.9617 24.1277 19.709 24.4395 19.709H31.4355C31.7473 19.709 32 19.9617 32 20.2735V24.3965C32 26.6401 30.1812 28.459 27.9375 28.459C25.6938 28.459 23.875 26.6401 23.875 24.3965V20.2735Z",
    fill: "url(#paint0_linear_6640_16243)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 19.2251C17.625 18.802 17.968 18.459 18.3911 18.459H26.8589C27.282 18.459 27.625 18.802 27.625 19.2251V25.334C27.625 28.0954 25.3864 30.334 22.625 30.334C19.8636 30.334 17.625 28.0954 17.625 25.334V19.2251Z",
    fill: "url(#paint1_linear_6640_16243)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.875,
    cy: 16.584,
    r: 1.875,
    fill: "#34439E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.875,
    cy: 16.584,
    r: 1.875,
    fill: "url(#paint2_linear_6640_16243)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.25,
    cy: 15.334,
    r: 2.5,
    fill: "url(#paint3_linear_6640_16243)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6640_16243",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 11,
    width: 11,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 17.834C24.3509 17.834 25.75 16.4349 25.75 14.709C25.75 12.9831 24.3509 11.584 22.625 11.584C20.8991 11.584 19.5 12.9831 19.5 14.709C19.5 16.4349 20.8991 17.834 22.625 17.834Z",
    fill: "url(#paint4_linear_6640_16243)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3911 18.459C17.968 18.459 17.625 18.802 17.625 19.2251V25.334C17.625 28.0954 19.8635 30.334 22.625 30.334C25.3865 30.334 27.625 28.0954 27.625 25.334V19.2251C27.625 18.802 27.282 18.459 26.8589 18.459H18.3911Z",
    fill: "url(#paint5_linear_6640_16243)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6640_16243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.375 20.209C16.375 18.5521 17.7181 17.209 19.375 17.209H21.5C23.1569 17.209 24.5 18.5521 24.5 20.209V25.459C24.5 27.1158 23.1569 28.459 21.5 28.459H16.375V20.209Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15.959,
    width: 11.25,
    height: 11.25,
    rx: 2,
    fill: "url(#paint6_linear_6640_16243)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 18.459H15.125V19.6057H16.9968V24.709H18.2532V19.6057H20.125V18.459Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6640_16243",
    x: 0,
    y: 0.583984,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6640_16243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6640_16243",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6640_16243",
    x1: 23.875,
    y1: 20.1695,
    x2: 32.0994,
    y2: 25.5437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6640_16243",
    x1: 17.625,
    y1: 23.7114,
    x2: 27.625,
    y2: 23.7114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515FC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7084EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6640_16243",
    x1: 27,
    y1: 14.9064,
    x2: 30.6227,
    y2: 17.4557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6640_16243",
    x1: 21.4643,
    y1: 13.5483,
    x2: 24.6786,
    y2: 17.2983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6640_16243",
    x1: 20.3929,
    y1: 12.4768,
    x2: 24.4107,
    y2: 17.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6640_16243",
    x1: 20.3929,
    y1: 12.4768,
    x2: 24.4107,
    y2: 17.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4858AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E60CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6640_16243",
    x1: 12,
    y1: 21.584,
    x2: 23.25,
    y2: 21.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C56B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/Teams.351b86643f227ee2294476ad3f9fcaa6.svg";
export { ForwardRef as ReactComponent };